import firebase from 'gatsby-plugin-firebase';

export const regulamentoClick = () => {
  firebase
    .analytics()
    .logEvent('regulamento_click');

  window.open('https://storage.googleapis.com/hackathonagritech.appspot.com/Hackathon%20Regulamento%20La%20Salle%202020.pdf', '_blank');
}

export const symplaClick = () => {
  firebase
    .analytics()
    .logEvent('sympla_click');

  window.open('https://www.sympla.com.br/hackathon-agritech-unilasalle-lucas-do-rio-verdemt__805357', '_blank');
}